module.exports = __webpack_public_path__ + "static/img/animales_24.6c9c66de.jpg";